import { Stack, Typography } from '@mui/material';
import { Gauge } from '@mui/x-charts/Gauge';

interface GaugeChartComponentProps {
    height?: number;
    title: string;
    value: number;
}

function GaugeChartComponent({ height = 200, title, value }: Readonly<GaugeChartComponentProps>) {
    return (
        <Stack
            sx={{
                flex: 1,
            }}
        >
            <Typography variant="subtitle2">
                {title}: {value.toFixed(1)}
            </Typography>
            <Stack
                direction={{ md: 'row', xs: 'column' }}
                sx={{
                    alignItems: 'center',
                    flex: 1,
                    justifyContent: 'space-evenly',
                }}
            >
                <Stack>
                    <Typography sx={{ display: 'block', textAlign: 'center' }} variant="subtitle2">
                        Standard
                    </Typography>
                    <Gauge height={height} value={value} valueMax={100} valueMin={0} width={height} />
                </Stack>

                <Stack>
                    <Typography sx={{ display: 'block', textAlign: 'center' }} variant="subtitle2">
                        Semi-circle
                    </Typography>
                    <Gauge
                        endAngle={90}
                        height={200}
                        startAngle={-90}
                        value={value}
                        valueMax={100}
                        valueMin={0}
                        width={200}
                    />
                </Stack>
            </Stack>
        </Stack>
    );
}

export default GaugeChartComponent;
